import React, { useState } from "react";
import { connect } from "react-redux";
import ct from "class-types.macro";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
import AddToCartButton from "~/productListing/ProductBox/AddToCart";
import { Item } from "~/common/Carousel";
import CarouselMemberProduct from "~/productListing/ProductBox/CarouselMemberProduct";

interface Props {
  product: Product;
  user: UserState;
  discountCode: string;
}

const CarouselMember = ({ product, user, discountCode }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct>({
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
  });

  return (
    <Item sliderRight key={product.itemNumber} classNames={ct("p-4", "w-40")}>
      <CarouselMemberProduct
        {...product}
        price={selectedProduct.price}
        isOutlet={selectedProduct.isOutlet}
      />
      <div>
        <AddToCartButton
          {...{
            product,
            user,
            selectedProduct,
            setSelectedProduct,
            isCarouselProductBox: true,
            discountCode,
            outOfStockStyle:
              "font-semibold text-base leading-none overflow-hidden relative text-center text-red-500 xxxs:ml-1",
          }}
        />
      </div>
    </Item>
  );
};

export const mapStateToProps = (state: RootState) => ({ user: state.user });

export default connect(mapStateToProps)(CarouselMember);
